"use strict";

angular.module("core")
.factory("SupportAssistantInterceptor", function($rootScope, $q, $timeout) {
    return {
        responseError: function(rejection) {
            $timeout(
                function() {
                    $rootScope.$broadcast("onAPIError", rejection);
                }
            );
            return $q.reject(rejection);
        }
    }
})
.config(function($httpProvider) {
    $httpProvider.interceptors.push("SupportAssistantInterceptor");
});



//////////////////
// WEBPACK FOOTER
// ./core/support-assistant/support-assistant.interceptor.js
// module id = 404
// module chunks = 0